import React from 'react'
import PropTypes from 'prop-types'
import {useStyleConfig, Box, Text} from '@chakra-ui/react'
import {CheckIcon} from '../../../icons'

const AccordionList = ({lists, styleVariant}) => {
    const styles = useStyleConfig('Accordion', {variant: styleVariant})

    if (!Array.isArray(lists) || lists.length === 0) return

    return (
        <Box {...styles.accordionList}>
            {lists.map((list, index) => (
                <Box
                    key={index}
                    {...styles.accordionPanelElement}
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    gap={0}
                    width="100%"
                >
                    <Text
                        as="h4"
                        m={0}
                        {...styles.accordionPanelTextList}
                        display="block"
                        width="100%"
                    >
                        {list?.value_name && list.value_name}
                    </Text>
                    <Text
                        as="p"
                        m={0}
                        {...styles.accordionPanelTextListValue}
                        display="block"
                        width="100%"
                    >
                        {list?.has_check ? (
                            <CheckIcon data-testid="check-icon" {...styles.checkIconBox} />
                        ) : (
                            <>{list?.value && list.value}</>
                        )}
                    </Text>
                </Box>
            ))}
        </Box>
    )
}

AccordionList.propTypes = {
    lists: PropTypes.arrayOf(
        PropTypes.shape({
            value_name: PropTypes.string,
            has_check: PropTypes.bool,
            value: PropTypes.node,
        }),
    ),
    styleVariant: PropTypes.string,
}

export default AccordionList
